import {
  Avatar,
  Container,
  Drawer,
  Grid,
  LinearProgress,
  Paper,
  Tooltip
} from '@mui/material';
import React, {useContext, useState} from 'react';
import { makeStyles } from 'tss-react/mui';
import { AppContext } from 'src/utils/appContext';
import { Account } from '@vectopus/atlas-icons-react';
import ModalLanguages from '../step1/modal/ModalLanguages';
import DrawerCart from '../DrawerCart';
import {useResponsive} from "src/hooks/use-responsive";
import ModalCartExpire from "../ModalCartExpire";
import ModalProfile from "../ModalProfile";
import ProfileNav from './ProfileNav';
import {getLogo, website} from '@/utils/helpers';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';

const HeaderLinks = () => {
  const appContext = useContext(AppContext);
  const upMd = useResponsive('up', 'md');
  const downMd = useResponsive('down', 'md');



  const { classes } = useStyles();

  const [openLanguagesModal, setOpenLanguagesModal] = useState(false);
  const [openProfileModal, setOpenProfileModal] = useState(false);

  const handleModalLanguage = () => {
    setOpenLanguagesModal(!openLanguagesModal);
  };

  const handleModalProfile = () => {
    setOpenProfileModal(!openLanguagesModal);
  };

  const handleCart = () => {
    appContext.setDrawerCart(!appContext.drawerCart);
  }

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };




  return (
    <>
      <Paper className={classes.header}>
        <Container maxWidth={'xl'}>
          {
            downMd && (
              <Grid
                container
                direction={'row'}
                alignItems={'center'}
                justifyContent={'center'}
                className={classes.mobileNav}>
                <Grid item xs={8} textAlign={'center'} p={1}>
                  <a href={appContext.language === 'en' ? '/' : `/${appContext.language}`}>
                    <img src={getLogo()} height={website.logo.height} width={website.logo.width} alt={website.logo.alt} />
                  </a>
                </Grid>
                <Grid item xs={4} pr={4}>
                  <Grid
                    container
                    direction={'row'}
                    alignItems={'unset'}
                    justifyContent={'flex-end'}
                    spacing={1}>
                    <Grid
                      item
                      sx={{ display: 'flex', alignItems: 'center' }}
                      onClick={() => {
                        handleCart();
                      }}>
                      {/*<Badge badgeContent={appContext.cart.length} color={'primary'}>
                        <LuggageTrolley size={20} />
                      </Badge>*/}
                    </Grid>

                    <UnauthenticatedTemplate>
                      <Grid item onClick={() => appContext.handleLogin()}>
                        <Tooltip title="Account settings">
                          <Account size={20} />
                        </Tooltip>
                      </Grid>
                    </UnauthenticatedTemplate>
                    <AuthenticatedTemplate>
                      <Grid item onClick={() => {
                        handleModalProfile();
                      }}>
                        <Avatar
                          alt={`${appContext.accountData?.firstName} ${appContext.accountData?.lastName}`}
                          src={''}
                        />
                      </Grid>
                    </AuthenticatedTemplate>
                  </Grid>
                </Grid>
              </Grid>
            )
          }

          <Grid container direction={'row'} alignItems={'center'} justifyContent={'center'}>
            {
              upMd && (
                <Grid item xs={2} md={1} lg={2}>
                  <a href={appContext.language === 'en' ? '/' : `/${appContext.language}`}>
                    <img src={getLogo()} height={website.logo.height} width={website.logo.width} alt={website.logo.alt}/>
                  </a>
                </Grid>
              )
            }

            {
              upMd && (
                <Grid item xs={12} sm={12} md={8}>
                  {/*<Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={3}>
                    <Grid item>
                      <Typography variant={'body1'} component={'p'}>choose your hu</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant={'body1'} component={'p'}>destinations</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant={'body1'} component={'p'}>our openair</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant={'body1'} component={'p'}>tailor-made for you</Typography>
                    </Grid>
                  </Grid>*/}
                </Grid>
              )
            }

            {
              upMd && (
                <Grid item xs={2}>
                  <Grid
                    container
                    direction={'row'}
                    alignItems={'unset'}
                    justifyContent={'flex-end'}
                    spacing={1}>
                    <Grid
                      item
                      sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
                      onClick={() => {
                        handleCart();
                      }}>
                      {/*<Badge badgeContent={appContext.cart.length} color={'primary'}>
                        <LuggageTrolley size={24} />
                      </Badge>*/}
                    </Grid>

                    {
                      website.code !== 'VP' && website.code !== 'CE' && (<ProfileNav />)
                    }

                    <Grid item onClick={handleModalLanguage} sx={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={`https://huopenair.s3.eu-central-1.amazonaws.com/theme_hu/lingue/lingua_${appContext.language}@2x.png`}
                        alt={appContext.language}
                        width={24}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )
            }
          </Grid>
        </Container>

        <Drawer
          anchor={'right'}
          open={appContext.drawerCart}
          className={classes.rootDrawer}
          onClose={() => {
            appContext.setDrawerCart(!appContext.drawerCart);
          }}>
          <DrawerCart />
        </Drawer>

        <ModalProfile
          params={{ handleModalProfile, openProfileModal, setOpenProfileModal }}
        />

        <ModalCartExpire />

        <ModalLanguages
          params={{ handleModalLanguage, openLanguagesModal, setOpenLanguagesModal }}
        />
      </Paper>

      {appContext.requestsActive && appContext.requestsActive > 0 ? <LinearProgress /> : ''}
    </>
  );
};

export default HeaderLinks;

const useStyles = makeStyles()((theme) => {
  return {
    header: {
      [theme.breakpoints.up('md')]: {
        padding: '30px 0'
      },
      position: 'sticky',
      width: '100%',
      left: 0,
      zIndex: 0,
      '& .MuiAvatar-circular': {
        width: 30,
        height: 30
      },
      '& .MuiBadge-badge': {
        fontFamily: theme.typography.body1.fontFamily,
        backgroundColor: theme.palette.secondary.main
      },
      '& .MuiContainer-root': {
        padding: 0,
        [theme.breakpoints.down('xl')]: {
          maxWidth: 1200
        },
        [theme.breakpoints.down('md')]: {
          width: '100%'
        },
        [theme.breakpoints.down('sm')]: {
          padding: '0'
        }
      },
      img: {
        cursor: 'pointer'
      },
      svg: {
        cursor: 'pointer',
        verticalAlign: 'initial'
      }
    },
    mobileNav: {
      [theme.breakpoints.down('md')]: {
        backgroundColor: theme.palette.primary.main
      }
    },
    rootDrawer: {
      '& .MuiPaper-root': {
        width: 390,
        padding: '20px 50px',
        backgroundColor: '#F2F2F2',
        [theme.breakpoints.down('sm')]: {
          padding: 36,
          width: '-webkit-fill-available'
        }
      }
    },
    profileNav: {
      '.MuiPaper-root': {
        boxShadow: '0px 2px 12px #00000029',
        border: 'none',
        marginTop: 20,
        'a': {
          textDecoration: 'none',
          color: '#000'
        }
      }
    },
    notifyContainer: {
      position: 'absolute',
      backgroundColor: '#FFEE00',
      padding: '15px 20px',
      display: 'flex',
      alignItems: 'center',
      width: 170,
      top: 65,
      left: '-160px',
      '&:after': {
        content: '""',
        position: 'absolute',
        height: 0,
        width: 0,
        top: -14,
        right: 15, /* 1px buffer for zooming problems while rendering*/
        borderWidth: 7,
        borderColor: 'transparent #ffee00 transparent transparent',
        borderStyle: 'solid',
        transform: 'rotate(90deg)'
      }
    }
  };
});
